export function notEmpty<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

export function stripUndef<T>(x: T): T {
  return JSON.parse(JSON.stringify(x));
}

/**
 * from https://github.com/piotrwitek/utility-types/blob/master/src/mapped-types.ts
 * Subtract
 * @desc From `T` remove properties that exist in `T1` (`T1` has a subset of the properties of `T`)
 * @example
 *   type Props = { name: string; age: number; visible: boolean };
 *   type DefaultProps = { age: number };
 *
 *   // Expect: { name: string; visible: boolean; }
 *   type RestProps = Subtract<Props, DefaultProps>;
 */
// ts-prune-ignore-next
export type Subtract<T extends T1, T1> = Pick<T, Exclude<keyof T, keyof T1>>;
